import cx from 'classnames';
import { FunctionComponent, useMemo } from 'react';

import getCategoryNames from './utils/get-category-by-slug';

type VehiclePreview = {
  selection: TCategorySelection;
  groups: Array<TCategory>;
  textAlign?: 'center' | 'left' | 'right';
};

const PartPreview: FunctionComponent<VehiclePreview> = ({
  selection,
  groups,
  textAlign,
}) => {
  const info = useMemo(
    () => getCategoryNames(selection, groups),
    [selection, groups]
  );

  return (
    <div className="bg-neutral-80 w-fit rounded-full px-4">
      <span
        className={cx(
          'text-base font-[400]',
          'lg:text-[18px]',
          'text-ce',
          'text-white'
        )}
      >
        {info.category}
      </span>
    </div>
  );
};

export default PartPreview;
